<template>
  <div class="training-school">
    <div class="training-school-inner">
      <div class="training-school-head">
        评分
      </div>
      <!-- 渐变线条 -->
      <div class="gitern"></div>
      <div class="trainingvideo">
        <div class="trainingvideright">
          <div
            class="trainingimgli"
            v-for="(item,index) in QuestionList"
            :key="index"
            @click="newsVideo(item.id,item)"
          >
            <img :src="item.imgUrl ? item.imgUrl: defaultImg " />

            <div class="traingimgtext" :title="item.filename">{{item.filename}}</div>
            <!-- <div style="padding-left:10px;padding-top:5px">
              <el-rate v-model="item.levels" disabled disabled-void-color="#cccccc"></el-rate>
            </div>-->
            <div class="traingimgnametxtlil">
              <div class="traingimgtext" style="font-size:14px;color:#888">作者：{{item.createname}}</div>
              <div style="flex:1"></div>
              <div class="traniBox">
                <div class="trainicon">
                  <img src="@/assets/videoimg/u5260.png" alt />
                  <span style="padding-left: 10px;">{{item.score}}</span>
                </div>
              </div>
            </div>
          </div>
          
          <nodata v-if="QuestionList.length==0" style="margin: 0 auto; margin-top: 100px;"></nodata>
        </div>
        
      </div>
      
    </div>
    <div class="pagination">
            <el-pagination
              background
              prev-text="上一页"
              next-text="下一页"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="listQuery.page"
              :page-sizes="[10, 20, 40, 80]"
              :page-size="listQuery.limit"
              layout="total,sizes, prev, pager, next"
              :total="trainCount"
              v-if="trainCount>0"
            ></el-pagination>
          </div>
  </div>
</template>

<script>
import * as studyClassIndex from '@/api/studyClass/index';
import * as personcen from '@/api/personcenter/index.js';
import treeSelectt from '@/components/treeSelectt'; //文本框选中部门树形结构异步加载
import elSelectc from '@/components/elSelect';
export default {
  props:["GradeId"],
  components: {
    treeSelectt,
    elSelectc,
  },
  data() {
    return {
      QuestionList: [],
      levels: 5,
      tabActive: 0,
      listQuery: {
        title: '',
        address: null,
        deptId: 0,
        JzId: null,
        type: '',
      },
      tablist: [
        {
          title: '五星级精品',
          id: 5,
        },
        {
          title: '四星级精品',
          id: 4,
        },
      ],
      options: [
        {
          value: 1,
          label: '专业课',
        },
        {
          value: 3,
          label: '公共课',
        },
      ],
      sid: +new Date(),
      typeOne: 0, //传0过去只显示部门，不穿显示所有部门
      parentIdOne: 1, //只显示该部门以下的
      defaultCheckedKeys: [],
      listQuerypingf: {
        page: 1,
        limit: 10,
        count: 0,
        activityId: 0,
      },
      trainCount:0,
      defaultImg:require('@/assets/videoimg/videopaly2.png'),

    };
  },
  mounted() {
    this.MoocQuestionList();
  },
  methods: {
     handleCurrentChange(val) {
      this.listQuery.page = val;
      this.MoocQuestionList();
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.MoocQuestionList();
    },
    MoocQuestionListssstt() {
      this.$router.push('/mooc/policeAcademyMore');
    },
    // 类型
    selectChanType(val) {
      console.log(val);
      this.$router.push('/mooc/policeAcademyMore');
    },
    // 选择警钟类型返回
    selectDatajzDicId(val) {
      this.listQuery.jzId = val.value;
      this.$router.push('/mooc/policeAcademyMore?jzId=' + val.value);
      // this.MoocQuestionList();
    },
    //警种部门
    AddDept(checkedIds, checkedData) {
      // console.log(checkedData);
      this.listQuery.deptId = checkedData.id;
      this.$router.push('/mooc/policeAcademyMore?deptId=' + checkedData.id);
    },
    // 更多
    acadMore() {
      this.$router.push('/mooc/policeAcademyMore');
    },
    MoocQuestionList() {
      this.listQuerypingf.activityId = this.GradeId;
      this.listQuerypingf.Status= 1;
      personcen.LoadActivityResource(this.listQuerypingf).then((res) => {
        this.QuestionList = res.data;
        this.trainCount= res.count;
      });
      // let data = { top: 10, levels: this.levels };
      // studyClassIndex.GetWkStartList(data).then((res) => {
      //   this.QuestionList = res.result;
      // });
    },
    //跳转到新页面进入视频的播放
    newsVideo(id,item) {
      this.$router.push({
        path:'/personCenter/gradedafen',
        query:{
          id: id,
          activityid:item.activityid

        }
      });
    },
    tabHandleChange(index, id) {
      this.tabActive = index;
      this.levels = id;
      this.$emit('tabChange', this.tabActive);
      this.MoocQuestionList();
    },
  },
};
</script>

<style lang="scss" scoped>
.training-school {
  font-family: '微软雅黑', sans-serif;
  > .training-school-inner {
    width: 1200px;
    min-height: 600px;
    margin: 0 auto;
    border-radius: 6px;
    background-color: #fff;
    .training-school-head {
      font-size: 22px;
      font-weight: 700;
      height: 56px;
      width: 100%;
      display: flex;
      align-items: center;
      // padding: 3px 10px 3px 8px;
      background-image: url('http://121.12.125.214:2364/images/%E5%BE%AE%E8%AD%A6%E6%A0%A1/u2159.svg');
      background-repeat: no-repeat;
      background-size: 100% 100%;
      -moz-background-size: 100% 100%;
      @include themeify {
        border-color: themed('color-border-base');
      }
      .training-schoolul {
        flex: 1;
        display: flex;
        line-height: 50px;
        .training-school-headtext {
          font-size: 22px;
          font-weight: 500;
          line-height: 37px;
          margin-left: 20px;

          // @include style-h(0.9);

          @include themeify {
            color: themed('color-text-secondary');
            border-color: themed('color-border-base');
          }
          &.active {
            @include themeify {
              color: #1492ff;
              font-weight: 700;
              border-bottom-color: themed('color-background-base');
            }
          }
        }
      }
    }
    .trainingvideo {
      padding: 24px 0;
      display: flex;
      .trainingvideright {
        display: flex;
        flex-wrap: wrap;
        width: 100%;
        .trainingimgli {
          width: 228px;
          border: 1px solid #f2f2f2;
          cursor: pointer;
          margin: 0 5px 20px 5px;
          border-radius: 5px;
          &:hover {
            box-shadow: 2px 2px 6px rgb(242 242 242 / 99%);
            transform: scale(1.02);
            border-radius: 5px;
          }
          img {
            width: 100%;
            height: 205px;
            border-radius: 6px 6px 0 0;
          }
          .traingimgtext {
            // display: flex;
            align-items: center;
            font-size: 16px;
            overflow:hidden;
            text-overflow:ellipsis;
            white-space:nowrap;
            // width: 126px;
            margin-top: 6px;
            padding-left: 10px;
          }
          .traingimgnametxtlil {
            color: #999;
            font-size: 14px;
            display: flex;
            margin-top: 6px;
            padding-bottom: 10px;
            .traingimgname {
              padding: 3px 5px;
              color: #fff;
              background-color: #4876c4;
              border-radius: 4px;
              font-size: 13px;
              margin-right: 8px;
            }
            .traniBox {
              // flex: 1;
              display: flex;
              padding-right: 5px;
              .trainicon {
                flex: 1;
                display: flex;
                justify-content: center;
                align-items: center;
                font-size: 12px;
                img {
                  width: 20px;
                  height: 20px;
                  margin-right: 2px;
                }
              }
            }
          }
        }
      }
    }
  }
}

.gdbox {
  display: flex;
  align-items: center;
  line-height: 50px;
  color: #1492ff;

  .gdtext {
    font-size: 16px;
    font-weight: 400;
    cursor: pointer;
    &:hover {
      text-decoration: underline;
      color: #1492ff;
    }
  }
  .gdimg {
    margin: 0 10px 0 8px;
  }
}

.play-btn {
  font-size: 50px;
  color: #fff;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  &:hover {
    cursor: pointer;
  }
}
.gitern {
  height: 1px;
  width: 100%;
  background: linear-gradient(139deg, #1492ff, #d51919);
}
.search-box {
  width: 1200px;
  border-radius: 5px;
  height: 80px;
  background-color: #5c7dbd;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  .select-box {
    display: flex;
    align-items: center;
    .select-title {
      color: white;
      font-weight: 700;
      font-size: 16px;
    }
  }
}
.pagination {
  margin-top: 20px;
  text-align: center;
}
</style>
